import { webLogger } from '@muse-web/logger'
import { loadWithChunkRetry } from '@muse-web/router'

import { reportWebVital } from './reportWebVital'

export const trackWebVitals = (): void => {
    loadWithChunkRetry(() => import(/* webpackChunkName: 'web-vitals' */ 'web-vitals/attribution'))
        .then(({ onINP, onTTFB, onFCP, onLCP, onCLS }) => {
            const opts = { reportSoftNavs: true }

            onINP(reportWebVital, opts)
            onTTFB(reportWebVital, opts)
            onFCP(reportWebVital, opts)
            onLCP(reportWebVital, opts)
            onCLS(reportWebVital, opts)
        })
        .catch((error: unknown) => {
            webLogger.error(error instanceof Error ? error : String(error))
        })
}
